import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles<{ isCentered: boolean }>({
	name: 'AccommodationHeader',
	uniqId: 'accommodation-header',
})((theme, { isCentered }) => ({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		marginBottom: theme.spacing.xsmall,
		width: '100%',

		[getFromBreakpoint('lg')]: {
			gap: theme.spacing.medium,
			marginBottom: theme.spacing.small,
		},
	},
	accoTypeLink: {
		marginBottom: 0,
	},
	basicInfo: {
		display: 'flex',
		flexDirection: 'column',
		rowGap: theme.spacing.small,
		alignItems: isCentered ? 'center' : 'normal',
		width: '100%',

		[getFromBreakpoint('md')]: {
			width: 'auto',
		},

		[getFromBreakpoint('lg')]: {
			flexDirection: 'row',
		},
	},
	header: {
		textAlign: isCentered ? 'center' : 'initial',
	},
	accoTypeWrapper: {
		display: 'flex',
		flexDirection: 'row',
		color: theme.accoTop.link.color.default,
		alignItems: isCentered ? 'center' : 'normal',
	},
	breadcrumbsWrapper: {
		display: 'flex',
		flexDirection: 'column',
		color: theme.accoTop.link.color.default,
		alignItems: isCentered ? 'center' : 'normal',
		width: '100%',

		[getFromBreakpoint('md')]: {
			flexDirection: 'row',
			width: 'auto',
		},
	},
	shareAccoLink: {
		color: theme.accoTop.link.color.default,
		display: 'flex',
		alignItems: 'center',
		'& svg': {
			color: theme.accoTop.link.color.default,
		},
	},
	accoReview: {
		color: theme.accoTop.link.color.default,
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing.xxsmall,
		'&:hover': {
			'& svg': {
				color: theme.palette.orange[100],
			},
		},
	},
}));
